import { render, staticRenderFns } from "./WebFormSubscriberCreateEdit.vue?vue&type=template&id=8b0cc76a"
import script from "./WebFormSubscriberCreateEdit.vue?vue&type=script&lang=js"
export * from "./WebFormSubscriberCreateEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports